import { translation, useSelector, TranslatedComponent } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import ApplicantServiceLayout from 'src/components/ApplicantServiceLayout';
import { ApplicantService, COMPLETE_RESUME_PACKAGES } from 'src/types/applicantServices';

import CareerGuidanceOrder from 'src/pages/ApplicantServicesOrder/components/CareerGuidance';
import CareerServiceOrder from 'src/pages/ApplicantServicesOrder/components/CareerService';
import ResumeAuditOrder from 'src/pages/ApplicantServicesOrder/components/ResumeAudit';

const SERVICE_COMPONENT_MAP = {
    [ApplicantService.ResumeAudit]: ResumeAuditOrder,
    [ApplicantService.CompleteResume]: CareerServiceOrder,
    [ApplicantService.CompleteResumeBase]: CareerServiceOrder,
    [ApplicantService.CompleteResumeOptimal]: CareerServiceOrder,
    [ApplicantService.CompleteResumeMaximal]: CareerServiceOrder,
    [ApplicantService.CompleteResumeConsultOnly]: CareerServiceOrder,
    [ApplicantService.CompleteResumeInterviewPractice]: CareerServiceOrder,
    [ApplicantService.CareerGuidance]: CareerGuidanceOrder,

    // переносить остальные сервисы будем в PORTFOLIO-18462
    [ApplicantService.ResumeRenewal]: () => null,
    [ApplicantService.TargetAgencies]: () => null,
    [ApplicantService.ResumeTargetEmployer]: () => null,
    [ApplicantService.VacancyResponsesSummary]: () => null,
    [ApplicantService.CareerMarathon]: () => null,
};

const ApplicantServicesOrder: TranslatedComponent<{ name?: string }> = () => {
    const serviceName = useSelectorNonNullable(({ orderServiceName }) => orderServiceName);
    const resumeAudit = useSelector(({ resumeAuditOrder }) => resumeAuditOrder);
    const careerService = useSelector(({ careerServiceOrder }) => careerServiceOrder);
    const orderStatus = serviceName === ApplicantService.ResumeAudit ? resumeAudit?.status : careerService?.status;
    let service = serviceName;
    if (serviceName === ApplicantService.CompleteResume) {
        switch (careerService?.packageType) {
            case COMPLETE_RESUME_PACKAGES.BASE: {
                service = ApplicantService.CompleteResumeBase;
                break;
            }
            case COMPLETE_RESUME_PACKAGES.OPTIMAL: {
                service = ApplicantService.CompleteResumeOptimal;
                break;
            }
            case COMPLETE_RESUME_PACKAGES.MAXIMAL: {
                service = ApplicantService.CompleteResumeMaximal;
                break;
            }
        }
    }
    const Component = SERVICE_COMPONENT_MAP[service];

    return (
        <ApplicantServiceLayout service={service} status={orderStatus}>
            <Component />
        </ApplicantServiceLayout>
    );
};

export default translation(ApplicantServicesOrder);
